'use strict'

export const SEARCH_ADDRESS = 'locations/SEARCH_ADDRESS';
